import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: 'transparent',
  },
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },
  title: {
    flexGrow: 1,
    fontSize: 14,
    margin: theme.spacing(1),
  },
  marginRight: {
    marginRight: 10,
  },
  gridPaper: {
    height: '100%',
    padding: 0,
  },
  tabsPaper: {
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
  },
  tabsPanel: {
    width: '100%',
  },
  tabBox: {
    margin: theme.spacing(3.5, 0, 0),

    '& > div > div': {
      padding: 0,
    },
  },
  boxPaper: {
    dispaly: 'flex',
    width: '300',
    marginTop: theme.spacing(2),
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
  },
  container: {
    // width: '50%',
    backgroundColor: '#ffffff',
    boxShadow: theme.shadows[0],
    padding: 32,
    // textAlign: 'center',
    fontSize: 20,
  },
  containerTitle: {
    color: '#b9b9b9',
  },
  containerDesc: {
    color: '#000000',
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(2),
  },
  btn: {
    padding: theme.spacing(1, 3.5),
    fontSize: 14,
    textTransform: 'none',
    width: 180,
    height: 56,
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',

    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'grey',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },

  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 40,
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  toolbarIcon: {
    paddingLeft: 0,
  },
  editIcon: {
    color: 'black',
  },
  heading: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '133.4%',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  mainHeading: {
    display: 'flex',
    // justifyContent: 'center',
    alignItems: 'center',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    color: '#000000',
    width: '40%',
  },
  header: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '133.4%',
    color: '#000000',
    margin: '24px 0',
    background: '#F6F6F6',
    padding: '10px 16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  myArrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  line: {
    width: '50%',
    border: '1px dashed grey',
  },
  arrow: {
    color: 'grey',
    display: 'flex',
    justifyContent: 'center',
    marginLeft: '-8px',
    fontSize: '24px',
  },
  arrowContainer: {
    width: '20%',
  },
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  border: {
    border: '1px solid #E0E0E0',
  },
  cellTitle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
    width: '50%',
  },
  cellHead: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
    width: '25%',
    textTransform: 'uppercase',
  },
  cellContent: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
    width: '25%',
  },
  center: {
    textAlign: 'center',
  },
  progressBarContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  progressBar: {
    margin: '10px 0px',
    width: '70%',
  },
  active: {
    backgroundColor: '#fafafa',
  },
  listSourseLabel: {
    padding: 10,
    fontSize: 16,
    fontWeight: 600,
    backgroundColor: '#5081FF',
    color: 'white',
  },
  tabPaper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
  },
  MuiBox: {
    padding: 0,
  },
  row: {
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  // title: {
  //   margin: theme.spacing(0, 3.5, 0, 0),
  //   fontSize: 14,
  //   letterSpacing: 0.15,
  //   color: 'rgb(0 0 0 / 54%)',
  // },
  desc: {
    width: 'calc(100% - 160px)',
    //borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  // gridPaper: {
  //   height: '100%',
  // },
  // tabsPanel: {
  //   width: '60%',
  // },
  textBox: {
    margin: theme.spacing(3, 0),
    fontSize: 14,
    maxWidth: 600,
    color: 'rgb(0 0 0 / 54%)',
  },
  cellRow: {
    cursor: 'pointer',
  },
  // btnBox: {
  //   display: 'flex',
  //   justifyContent: 'flex-start',
  //   marginTop: theme.spacing(3),
  // },
  // btn: {
  //   padding: theme.spacing(1, 3.5),
  //   fontSize: 14,
  //   textTransform: 'none',
  // },
}));
